// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"757": "15c77b169cb28658","972": "d8228914b6ecb4bd",}[chunkId] + ".js"
}